import { RpErrorBoundary } from '@zg-rentals/rp-bootstrap-browser';

type NextErrorBoundary = 'app' | 'global';

type NextBoundaryError = Error & { digest?: string };

const componentStackByBoundary = {
  app: 'Next app error boundary',
  global: 'Next global error boundary',
} as const;

export function logNextErrorBoundary(error: NextBoundaryError, boundary: NextErrorBoundary) {
  const additionalContext: Record<string, unknown> = { boundary: `next-${boundary}` };

  if (error.digest) {
    additionalContext.digest = error.digest;
  }

  RpErrorBoundary.logError(error, { componentStack: componentStackByBoundary[boundary] }, additionalContext);
}
